<template>
  <div>
    <div class='top'>信息列表
    </div>
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>
    <div  class="maskbox show-up" v-if="showConfirm">
      <div class="confirm">
        <van-loading type="spinner"/><br/>提交中...
      </div>
    </div>
    <div class='record' ref="list" id="list">
      <div v-for='(item, index) in recordList.list' :key='index' class='record-list-item'>
        <div>{{ item.name }}</div>
        <div class='big-item'>{{ item.schoolName }}</div>
        <div @click="sendContract(item)" class="link">签署同意书</div>
      </div>
    </div>
    <div class='r-query' @click='goQuery'>
      <button class="btn">添加其他参与者信息</button>
    </div>
    <div v-if="showPhone" class="maskbox">
      <div class="mask" style="padding-bottom: 0.3rem;">
        <div class="maskclose" @click="closePhone">
          <img src="../assets/img/close.png" />
        </div>
        <div class="phone-title">提示</div>
        <div class="phone-tip">请填写签署同意书的监护人信息</div>
        <div class="input-div">
        <van-field v-model="name" required clearable label="姓名" placeholder="请输入姓名" /></div>
          <div class="input-div">
        <van-field v-model="idCard" required clearable label="身份证号" placeholder="请输入身份证号" /></div>
          <div class="input-div">
          <van-field v-model="phone" type="number" required clearable label="手机号" placeholder="请输入手机号" />
        </div>
        <div class="input-div">
          <van-field v-model="code"  type="digit"
            maxlength=6 required clearable label="验证码" placeholder="请输入验证码" style="width: 4.2rem;">
          </van-field>
          <van-button type="info" @click="getCode" class="code-btn" :disabled="isCode">
            {{ codeTxt }}
          </van-button>
        </div>
        <van-button type="info" @click="goSubmit" class="btn">
          确定
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list",
  data() {
    return {
      showConfirm: 0,
      showLoading: 1,
      recordList: { list: '' },
      isLoad: false,
      openId: '',
      showPhone: false,
      codeTxt: '发送验证码',
      phone: '',
      code: '',
      isCode: false,
      countDown: 60,
      student: {},
      name: '',
      idCard: '',
      timeDown: null,
      isSend: false,
    };
  },
  mounted() {
    let _this = this;
    _this.openId = _this.$route.query.openId;

    _this.getTitle();
    _this.getData(_this.openId);
  },
  methods: {
    /**
     * 获取数据
    */
    async getData(openId) {
      let auth = this.$createAuth(this.$md5);
      let _this = this;
      if (!this.isLoad) {
        this.isLoad = true;
        let hospitalId = this.$route.query.hospitalId;
        if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
        let result = await this.$http.get(this.$url.getRelatedstudentList, {
          openId: openId,
          hospitalId: hospitalId,
          auth: auth.code,
          time: auth.time
        });
        if (result.message === 'Error: Miss auth parameter.') {
          setTimeout(function () {
            _this.showLoading = 0;
            _this.isLoad = false; _this.getData(openId);
          }, 500);
        } else {
          this.showLoading = 0;
          let searchResultList = [...this.recordList.list, ...result.data.list]
          this.recordList.list = searchResultList;
          this.isLoad = false;
        }
      }
    },
    /**
     * 发送同意书
    */

    async sendContract(item) {
      if (!this.isSend) {
        this.isSend = true;
        this.student = item;
        this.showPhone = false;
        if (!item.guardian_phone || !item.guardian_name || !item.guardian_id_card) { 
          this.isSend = false; this.showPhone = true; return; }
        this.showConfirm = 1;
        let auth = this.$createAuth(this.$md5);
        await this.$http.get(this.$url.sendStudentContract, {
          openId: this.openId,
          uid: item.uid,
          auth: auth.code,
          time: auth.time
        }).then(res => {
          this.showConfirm = 0;
          this.isSend = false;
          // this.$toast(res.message)
          if(res.code==200){
            let signUrl = res.data.signUrl;
            window.location.href = signUrl
          }else{
            this.$toast(res.message)
          }
        })
      }
    },
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getTitle, {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      })
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data?.title
      }
    },
    goQuery() {
      this.$router.push(`/queryAgree?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&isAgree=true`);
    },
    async getCode() {
      if (!this.phone) {
        this.$toast("请填写手机号！");
        return;
      }
      if (this.phone != "") {
        let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
        if (!testPhone) {
          this.$toast("手机号填写错误！");
          return;
        }
      }
      this.isCode = true;
      this.codeTxt = '60秒后重新发送';
      this.timeDown = setInterval(() => {
        this.countDown--;
        this.codeTxt = this.countDown + '秒后重新发送';
        if (this.countDown == 0) {
          window.clearInterval(this.timeDown);
          this.isCode = false;
          this.codeTxt = '发送验证码';
          this.countDown = 60;
        }
      }, 1000);
      await this.$http.get(this.$url.sendCode, {
        openId: this.openId,
        phone: this.phone,
        stuId: this.stuId,
      });
      this.$toast("验证码已发送！");
    },
    async goSubmit() {
      if (!this.showConfirm) {
        if (this.name == "") {
          this.$toast("请填写姓名！");
          return;
        }
        if (this.idCard == "") {
          this.$toast("请填写身份证号码！");
          return;
        }

        if (this.idCard != "") {
          let yz1 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(this.idCard);
          let yz2 = /(^[a-zA-Z][0-9]{9})|(^[A-Z][0-9]{8})|(^[A-Z][0-9]{6}[(（][0-9a-zA-z][)）])$/.test(this.idCard);
          if (!yz1 && !yz2) {
            this.$toast("身份证号填写错误！");
            return;
          }
        }
        if (this.phone == "") { this.$toast("请填写手机号！"); return; }
        if (this.code == "") { this.$toast("请填写验证码！"); return; }
        if (this.phone != "") {
          let testPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[0123456789]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(this.phone)
          if (!testPhone) {
            this.$toast("手机号填写错误！");
            return;
          }
        }
        this.showConfirm = 1;
        let result = await this.$http.post(this.$url.setGuardianInfo, {
          openId: this.openId,
          guardianName: this.name,
          guardianPhone: this.phone,
          guardianIdCard: this.idCard,
          code: this.code,
          uid: this.student.uid
        });
        if (result.code == 200) {
          // this.$toast(result.message);
          this.recordList.list = [];
          this.getData(this.openId);
          let auth = this.$createAuth(this.$md5);
          await this.$http.get(this.$url.sendStudentContract, {
            openId: this.openId,
            uid: this.student.uid,
            auth: auth.code,
            time: auth.time
          }).then(res => {
            this.showConfirm = 0;
            this.closePhone();
            if (res.code == 200) {
              let signUrl = res.data.signUrl;
              window.location.href = signUrl
            } else {
              this.$toast(res.message)
            }
          })
        } else {
          this.showConfirm = 0;
          this.$toast(result.message);
        }
      }
    },
    closePhone() {
      this.name = '';
      this.phone = '';
      this.code = '';
      this.student = {};
      this.idCard = '';
      this.isCode = false;
      this.codeTxt = '发送验证码';
      window.clearInterval(this.timeDown);
      this.countDown = 60;
      setTimeout(() => {
        this.showPhone = false;
      }, 300);
    }
  }
};
</script>
<style scoped lang="less">
  /deep/ .van-field__label {
    margin-right: 0;
  } 
</style>
<style scoped lang="less">
.confirm {
  margin-top: 4rem;
  color: #fff;
  font-size: 0.4rem;
}
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.plus {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;

  img {
    width: 0.5rem;
  }
}

.record {
  width: 100%;
  padding-bottom: 3rem;

  .record-list-item {
    display: flex;

    div {
      width: 25%;
      height: 1rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 1rem;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #dddddd;

      &.big-item {
        width: 50%;
      }
    }

    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}

.r-query {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  line-height: 1rem;
  background: #fff;
  text-align: center;
}

.r-query .btn {
  width: 5.5rem;
  height: 1rem;
  margin: 0.4rem auto;
  color: #fff;
  border-radius: 5px;
  background: #5CC4AB;
}
.maskbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);

  .mask {
    width: 6.9rem;
    height: 7.2rem;
    margin: 30% auto;
    background: #fff;
    border-radius: 5px;
  }

  .maskclose {
    width: 100%;
    height: 0.5rem;

    img {
      width: 0.4rem;
      margin: 0.4rem;
      margin-left: 6rem;
    }
  }

  .codetip {
    width: 5rem;
    margin: 0 auto 0.3rem;
    line-height: 1.5em;
    font-size: 0.3rem;
  }

  .phone-title {
    margin-bottom: 0.3rem;
    line-height: 1.5em;
    font-weight: bold;
    font-size: 0.36rem;
  }
  .phone-tip {
    margin-bottom: 0.3rem;
  }
  .input-div {
    display: flex;
    width: 100%;
    height: 0.9rem;
    line-height: 0.9rem;
    border-bottom: 1px solid #eee;
  }
  .code-btn {
    height: 0.6rem;
    margin-top: 0.15rem;
    background: #5CC4AB;
    border: 0;
    font-size: 0.28rem;
  }
  .btn {
    width: 3rem;
    margin-top: 0.5rem;
    border: none;
    background: #5CC4AB;
  }
}
.show-up {
  z-index: 100;
}
</style>
